<template>
    <div id="login-news-list">
        <h3>Nowości</h3>
        <transition :name="activeTransition">
            <div class="elements" :key="currentPage">
                <div class="news-item" v-for="item in pageResults" @click="showElement(item)">
                    <div class="images-list">
                        <img :src="item.theme_image" class="news-image" />
                    </div>
                    <div class="description">
                        <h4>{{ item.title }}</h4>
                        <span class="text">{{ item.short_description }}</span>
                        <span class="date">{{ item.date }}</span>
                    </div>
                </div>
            </div>
        </transition>
        <div class="pagination" v-if="pageResults.length !== 0">
            <span class="arrow arrow-left"
                  v-show="hasPrev"
                  @click="previousPage()"
            ></span>
            {{ currentPage }}/{{ lastPage }}
            <span class="arrow arrow-right"
                  v-show="hasNext"
                  @click="nextPage()"
            ></span>
        </div>
    </div>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../../css/colors.scss";

    #login-news-list {
        position: relative;
        height: 724px;

        h3 {
            text-align: left;
            opacity: 0.7;
            user-select: none;
            line-height: 26px;
        }

        .elements {
            padding-left: 10px;

            .news-item {
                width: 100%;
                height: 150px;
                text-align: left;
                display: flex;
                align-items: center;
                margin: 10px 0;
                padding: 20px;
                border-radius: 15px;
                cursor: pointer;
                transition: background-color 0.2s;

                .images-list {
                    padding-right: 15px;
                    width: 165px;
                    text-align: center;

                    .news-image {
                        max-width: 150px;
                        max-height: 110px;
                    }
                }

                .description {
                    flex: 2 auto;
                    width: calc(100% - 165px);

                    h4 {
                        margin-top: 0;
                        font-weight: bold;

                        display: block;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .text {
                        text-align: justify;
                        font-size: 13px;
                        opacity: 0.7;
                        max-height: 4.4em;
                        overflow: hidden;
                        display: block;
                    }

                    .date {
                        margin-top: 10px;
                        display: block;
                        font-size: 12px;
                        font-style: italic;
                    }
                }

                &:hover {
                    background-color: white;

                    h4 {
                        color: $blue;
                    }

                    .text {
                        color: $dark-grey;
                        opacity: 0.87;
                    }

                    .date {
                        color: $green;
                    }
                }
            }
        }

        // Transitions
        .slide-right-enter-active {
            top: 26px;
            position: absolute;
            width: 100%;
        }

        .slide-right-leave-active {
            top: 26px;
            position: absolute;
            width: 100%;
        }

        .slide-left-enter-active {
            top: 26px;
            position: absolute;
            width: 100%;
        }

        .slide-left-leave-active {
            top: 26px;
            position: absolute;
            width: 100%;
        }
    }
</style>

<script>
    const PAGE_SIZE = 4;

    export default {
        name: 'LoginNewsList',
        props: {
            newsList: {
                type: Array,
                required: true,
            },
            currentPage: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                activeTransition: 'slide-right',
            };
        },
        computed: {
            pageResults() {
                const begin = PAGE_SIZE * (this.currentPage - 1);
                const end = PAGE_SIZE * this.currentPage;
                return this.newsList.slice(begin, end);
            },
            lastPage() {
                return Math.ceil(this.newsList.length / PAGE_SIZE);
            },
            hasPrev() {
                return this.currentPage > 1;
            },
            hasNext() {
                return this.currentPage < this.lastPage;
            },
        },
        methods: {
            nextPage() {
                this.activeTransition = 'slide-right';
                if (this.hasNext) {
                    this.currentPage += 1;
                    this.$emit('update:currentPage', this.currentPage);
                }
            },
            previousPage() {
                this.activeTransition = 'slide-left';
                if (this.hasPrev) {
                    this.currentPage -= 1;
                    this.$emit('update:currentPage', this.currentPage);
                }
            },
            showElement(item) {
                this.$emit('select', item);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// LoginNewsList.vue?f8f096d8